export default __webpack_public_path__ + "static/media/casalKMobile.8bf42ae8.png";